// @/lib/constants.js

export const GLOBAL_ASSETS = {
  // These images are constant for all 112 products
  frames: [
    { 
      id: "classic", 
      name: "Classic Frame", 
      url: "https://dlranh09xa.ufs.sh/f/wIfrl1CCrEbx6quENWmpICPbW73hSfNOUBavTFDJtui2zjQ4" 
    },
    { 
      id: "mani", 
      name: "Mani Frame", 
      url: "https://dlranh09xa.ufs.sh/f/wIfrl1CCrEbxyWMJjqqYhmXwJPlDEpos0iHTxvSk2b5aedZj" 
    },
    { 
      id: "chettinad", 
      name: "Chettinad Frame", 
      url: "https://dlranh09xa.ufs.sh/f/wIfrl1CCrEbxykFv7QYhmXwJPlDEpos0iHTxvSk2b5aedZj4" 
    }
  ]
};